import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Header from "./common/header/Header";
import CitySelectorModal from "./common/city/CitySelectorModal";
import DesktopNav from "../components/common/nav/DesktopNav";
import Footer from "../components/common/footer/Footer";
import { useTheme } from "../theme/ThemeProvider";
import FooterButton from "../components/common/footer/FooterButton";
import { SELL_DEVICE_ROUTE, CALCULATOR_ROUTE } from "../routes/constant";

const Layout = ({ children }) => {
  const { categories, loading } = useSelector((state) => state.home);
  const { isDarkMode } = useTheme();
  const location = useLocation();

  const skipnavigationPages = [SELL_DEVICE_ROUTE, CALCULATOR_ROUTE];

  // Check if current path matches any skip page
  const shouldSkipNav = skipnavigationPages.some((route) =>
    location.pathname.includes(route)
  );

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <Header />
      <CitySelectorModal />

      {/* Desktop Navigation */}
      {!loading && categories && categories.length > 0 && (
        <div
          className={`hidden md:block border-b mt-[70px] ${
            isDarkMode ? "bg-gray-900 border-gray-800" : "bg-white border-gray-200"
          }`}
        >
          <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <DesktopNav isDarkMode={isDarkMode} categories={categories} />
          </div>
        </div>
      )}

      {/* Footer Button - Hide on skip pages */}
      {!shouldSkipNav && <FooterButton isDarkMode={isDarkMode} />}

      {/* Mobile header: 56px navigation row + 40px search + 12px bottom padding. */}
      <main className="mt-[108px] md:mt-0">{children}</main>
      
      <Footer isDarkMode={isDarkMode} />
    </div>
  );
};

export default Layout;